import React from 'react';
import PropTypes from 'prop-types';
import { useI18nContext } from '@procore/core-react';
import {
  Card,
  CardLink,
  CardHeader,
  CardTitle,
  CardBody,
  CardImage,
  CardImageWrapper,
  CategoryCardDescription,
} from '@/react/components/AppCard/AppCard.styles';

const CategoryCard = ({ category }) => {
  const i18n = useI18nContext();

  return (
    <CardLink
      href={category.slug}
      variant="gray"
      className="skip-tablet-layout"
    >
      <Card
        display="flex"
        flexDirection="column"
        gap="sm"
        padding="lg"
        size="sm"
      >
        <CardHeader>
          <CardImageWrapper justifyContent="center" alignItems="center">
            <CardImage
              src={window.imagePath(category.image_path)}
              alt={i18n.t(category.nameKey)}
              height="152"
            />
          </CardImageWrapper>
        </CardHeader>
        <CardBody>
          <CardTitle>{i18n.t(category.nameKey)}</CardTitle>
          <CategoryCardDescription intent="body">
            {i18n.t(category.descriptionKey)}
          </CategoryCardDescription>
        </CardBody>
      </Card>
    </CardLink>
  );
};

CategoryCard.propTypes = {
  category: PropTypes.shape({
    nameKey: PropTypes.string.isRequired,
    descriptionKey: PropTypes.string.isRequired,
    image_path: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};

export default CategoryCard;
